import styled from "styled-components";

export const LabelContainer = styled.div`
	label {
		display: flex;
		flex-direction: column;
		row-gap: 5px;
		margin-bottom: 1em;
		width: 100%;
		max-width: 100%;

		p {
			margin: 0;
			font-size: 1em;
		}

		span {
			font-size: 1em;
		}

		input,
		select {
			padding-left: 1em;
			height: 45px;
			border: 1px solid #d9d9d9;
			width: 100%;
		}

		span.require {
			color: tomato;
			font-size: 14px;
			padding-top: 2px;
		}
	}
`;

export const Form = styled.div`
	margin-top: 25px;

	.submit-form {
		width: 100%;
		margin-bottom: 4em;
	}
`;

export const Mensage = styled.textarea`
	height: 165px;
	padding-left: 1em;
	padding-top: 0.75em;
	border: 1px solid #ccc;
`;

export const Container = styled.div`
	@media screen and (min-width: 0px) {
		.contact {
			padding-bottom: 5em;
		}

		.lengend {
			font-size: 1em;
		}
	}

	@media screen and (min-width: 992px) {
		.contact {
			padding-top: 2em;
			padding-bottom: 5em;

			.title {
				text-align: center;
			}
		}
	}
`;
